import Reclassify from './Reclassify';

export default Reclassify;
